var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"min-width-medium"},_vm._l((_vm.showData),function(value,key){return _c('li',{key:key,staticStyle:{"line-height":"1.5rem"}},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(key)+":")]),_vm._v(" "+_vm._s(value)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }